// Razorpay & Consultation Configuration for NumeroHub.in
const RAZORPAY_CONFIG = {
  // Option 1: Paste your Razorpay Key ID from Dashboard -> Settings -> API Keys (e.g. 'rzp_live_...' or 'rzp_test_...'):
  keyId: "rzp_live_TrjTWv5DPXz99i",
  
  // Option 2: If you use a hosted Razorpay Payment Link / Payment Button, paste the link here (e.g. 'https://rzp.io/l/...'):
  paymentLink: "",
  
  businessName: "NumeroHub",
  businessDescription: "Personalized Numerology & Name Correction",
  currency: "INR",
  
  supportEmail: "numerohub.en@gmail.com",
  
  // Google Sheets Auto-Sync Webhook (SheetMonkey Google Sheets Connector):
  googleSheetWebhookUrl: "https://api.sheetmonkey.io/form/w7PmGbvmJ4Fx4Z1Hpw4JDE",
  
  // Fixed Consultation Package (Fee: ₹199)
  package: {
    id: "numerology_correction",
    name: "Personalized Numerology Correction",
    tagline: "Personalized Numerology & Name Correction Guidance",
    price: 199,
    originalPrice: 1999,
    badge: "Negligible Blessing Fee",
    features: [
      "Personalized numerology correction"
    ]
  }
};
